// extracted by mini-css-extract-plugin
module.exports = {"form":"GeneralStripeEmailSetting_form__17TG5"};